import { TextMessagingConfiguration } from '@mews-commander/data-access';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { Banner, Body, Stack, Typography } from '@optimus-web/core';
import { OnlineCheckInFormContainer } from '../../OnlineCheckInForm/OnlineCheckInFormContainer';

interface OnlineCheckInTabProps {
    enterpriseId: string;
    configuration: TextMessagingConfiguration;
}

export const OnlineCheckInTab = ({ configuration, enterpriseId }: OnlineCheckInTabProps) => {
    const isV2Enabled = useFeatureFlag(FeatureFlag.textMessagingConfigurationV2Enabled);
    const primaryText = <LocalizedText textKey={TextKey.TextMessagingConfigurationOnlineCheckInBannerText} />;

    return (
        <Stack vertical spacing="400">
            <Stack vertical spacing="200">
                <Typography textStyle="titleSmall" as="p">
                    <LocalizedText textKey={TextKey.TextMessagingConfigurationGeneralDescription} />
                </Typography>
                <Banner primaryText={isV2Enabled ? primaryText : <Body>{primaryText}</Body>} variant="info" />
            </Stack>
            <OnlineCheckInFormContainer enterpriseId={enterpriseId} configuration={configuration} />
        </Stack>
    );
};
